"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.boldMatchedText = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var boldMatchedText = function(param) {
    var text = param.text, searchPhrase = param.searchPhrase;
    if (!text) {
        return null;
    }
    if (!searchPhrase) {
        return text;
    }
    var escapedSearchPhrase = searchPhrase.replaceAll(/[$()*+.?[\\\]^{|}]/g, '\\$&').trim();
    var regExpPattern = new RegExp(escapedSearchPhrase, 'igu');
    var splitText = text.split(regExpPattern);
    var matches = text.match(regExpPattern);
    if (!matches) {
        return text;
    }
    return splitText.map(function(el, index) {
        if (index > matches.length) {
            return el;
        }
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key -- there is nothing unique here and this array is not mutable
        (0, _jsxRuntime.jsxs)("span", {
            children: [
                el,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: matches[index]
                })
            ]
        }, "".concat(el, "-").concat(text, "-").concat(index)));
    });
};
exports.boldMatchedText = boldMatchedText; //# sourceMappingURL=boldMatchedText.js.map
